import { render, staticRenderFns } from "./PrivacyEn.vue?vue&type=template&id=3cf1f071&"
import script from "./PrivacyEn.vue?vue&type=script&lang=js&"
export * from "./PrivacyEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports